import classNames from 'classnames'

interface SortingIconProps {
    sort?: 'asc' | 'desc'
    onSort?: (desc: boolean) => void
}

const SortingIcon = ({ sort, onSort }: SortingIconProps) => {
    const handleSort = (desc: boolean) => (onSort ? () => onSort(desc) : undefined)

    return (
        <span className={classNames('dmn-sorting-icon', 'ms-2')}>
            <i
                className={classNames('bx', 'bxs-up-arrow', { active: sort === 'asc' })}
                style={onSort ? { cursor: 'pointer' } : undefined}
                onClick={handleSort(false)}
            />
            <i
                className={classNames('bx', 'bxs-down-arrow', { active: sort === 'desc' })}
                style={onSort ? { cursor: 'pointer' } : undefined}
                onClick={handleSort(true)}
            />
        </span>
    )
}

export default SortingIcon
